// extracted by mini-css-extract-plugin
export var arrow = "_3s-6";
export var changeItem = "_3s-3";
export var changesHeader = "_3s-1";
export var changesList = "_3s-2";
export var container = "_3s-0";
export var pathLabel = "_3s-4";
export var value = "_3s-7";
export var valuesContainer = "_3s-5";